import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "";
export const baseAPI = api(baseEndpoint);

const referralService = {
  referral: async (data: string) => {
    return baseAPI.post(`/Mobile/SelfService/Referral`, data);
  },
};
export default referralService;
